// src/PrivatePolicy.js
import './asset/App.css';
import Header from './component/Header';
import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

function PrivatePolicy() {

    return (
      <div className="App">
        <Header />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '95%', margin: 'auto' }}>
            <Typography variant="h4" sx={{ textAlign: 'left', mt: 3, mb: 3 }}>
                隱私權政策
            </Typography>
        </div>
        <Box>
            <Container maxWidth="md" sx={{ mt: 3 }}>  
                <div style={{ textAlign: 'left' }}>
                <p>歡迎您光臨「線上填寫勞務報酬單系統（以下簡稱本系統）」係由「內容電力股份有限公司（以下簡稱本公司）」所開發及經營。為了讓您能夠安心使用各項服務與資訊，向您說明遵循「個人資料保護法」之規定制定的隱私權保護政策，以保障您的權益，請您參考下列內容：</p>
                <p></p>
                <p><strong>一、個人資料之安全</strong></p>
                <p>在未經會員同意之下，我們絕不會將會員的個人資料提供予任何與本網站服務無關之第三人。會員應妥善保密自己的網路密碼及個人資料，不要將任何個人資料，尤其是網路密碼提供給任何人。在使用完本系統所提供的各項服務功能後，務必記得登出帳戶，若是與他人共享電腦或使用公共電腦，切記要關閉瀏覽器視窗。</p>
                <p></p>
                <p><strong>二、個人資料的蒐集、處理、利用</strong></p>
                <p>本系統所取得的個人資料，都僅供本公司於其內部、依照原來所說明的使用目的和範圍，除非事先說明、或依照相關法律規定，否則本公司不會將資料提供給第三人、或移作其他目的使用。</p>
                <p>蒐集之目的：<br />蒐集之目的在於進行行銷業務、消費者、客戶管理與服務、網路購物及其他電子商務服務及與調查、統計與研究分析(法定特定目的項目編號為Ｏ四Ｏ、Ｏ九Ｏ、一四八、一五七)。本公司將藉由加入會員之過程或進行交易之過程來蒐集個人資料。</p>
                <p>蒐集之個人資料類別包括，<br />(1) C001辨識個人者： 如會員之姓名、地址、電話、電子郵件等資訊。<br />(2) C002辨識財務者： 如信用卡或金融機構帳戶資訊。<br />(3) C011個人描述：例如：性別、出生年月日等。</p>
                <p>利用期間、地區、對象及方式：<br />(1) 期間：會員當事人要求停止使用或本公司停止提供服務之日為止。<br />(2) 地區：會員之個人資料將不限使用於台灣地區。<br />(3) 利用對象及方式：會員之個人資料蒐集除用於本公司之會員管理、客戶管理之檢索查詢等功能外，亦將利用於辨識身份、金流服務、物流服務、行銷廣宣等。例示如下：<br />a. 以會員身份使用本公司提供之各項服務時，於頁面中自動顯示會員資訊。<br />b. 為遂行交易行為：會員對商品或勞務為預約、下標、購買、參與贈獎等之活動或從事其他交易時，關於商品配送、勞務提供、價金給付、回覆客戶之詢問、本公司對會員之詢問、相關售後服務及其他遂行交易所必要之業務。<br />c. 宣傳廣告或行銷等：提供會員各種課程等資訊、透過電子郵件、郵件、電話、FB及Google再行銷等提供與服務有關之資訊。將會員所瀏覽之內容或廣告，依客戶之個人屬性或購買紀錄、本公司網站之瀏覽紀錄等項目，進行個人化作業、會員使用服務之分析、新服務之開發或既有服務之改善等。針對民調、活動、留言版等之意見，或其他服務關連事項，與會員進行聯繫。<br />d. 回覆客戶之詢問：針對會員透過電子郵件、郵件、傳真、電話或其他任何直接間接連絡方式向本公司所提出之詢問進行回覆。<br />e. 其他業務附隨之事項：附隨於上述a至d.之利用目的而為本公司提供服務所必要之使用。<br />f. 對於各別服務提供者之資訊提供：會員對服務提供者之商品或勞務為預約、下標、購買、參加贈獎活動或申請其他交易時，本公司於該交易所必要之範圍內，得將會員之個人資料檔案提供予服務提供者，並由服務提供者負責管理該個人資料檔案。本公司將以規約課予服務提供者依保障會員隱私權之原則處理個人資料之義務，但無法保證服務提供者會必然遵守。詳細內容，請向各別服務提供者洽詢。<br />g. 其他：提供個別服務時，亦可能於上述規定之目的以外，利用個人資料。此時將在該個別服務之網頁載明其要旨。</p>
                <p></p>
                <p><strong>三、會員就個人資料之權利</strong></p>
                <p>本公司所蒐集個人資料之當事人，依個人資料保護法得對本公司行使以下權利：</p>
                <p>查詢或請求閱覽。</p>
                <p>請求製給複製本。</p>
                <p>請求補充或更正。</p>
                <p>請求停止蒐集、處理或利用。</p>
                <p>請求刪除。</p>
                <p></p>
                <p><strong>四、個人資料查詢或更正的方式</strong></p>
                <p>會員對於其個人資料，有查詢及閱覽、製給複製本、補充或更正、停止電腦處理及利用、刪除等需求時，可以與本公司客服聯絡，我們將迅速進行處理。<br /><br />請注意！如拒絕提供加入會員所需必要之資料，將可能導致無法享受完整服務或完全無法使用該項服務。</p>
                <p></p>
                <p><strong>五、資料安全</strong></p>
                <p>為保障會員的隱私及安全，本公司會員帳號資料會用密碼保護。本公司並盡力以合理之技術及程序，保障所有個人資料之安全。</p>
                <p></p>
                <p><strong>六、Cookie</strong></p>
                <p>為了便利會員使用，本公司網站會使用cookie技術，以便於提供會員所需要的服務；cookie是網站伺服器用來和會員瀏覽器進行溝通的一種技術，它可能在會員的電腦中隨機儲存字串，用以辨識區別使用者，若會員關閉cookie有可能導致無法順利登入網站或無法使用購物車等狀況。</p>
                <p></p>
                <p><strong>七、隱私權保護政策修訂</strong></p>
                <p>本隱私權聲明將適時依據法律修正、相關技術之發展而配合修改並公告於網站，以落實保障您隱私權及網路安全之初衷，請您隨時上網察看。</p>
                </div>
            </Container>    
        </Box>
      </div>
    );
  }
  
  export default PrivatePolicy;